import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getBaseRequestData } from '../../../utils/evergentUtils';
import { KEYS } from '../../../utils/constants/storage.constants';
import { ConfigService } from '../../config.service';
import { BaseRequestModel } from '../base/base.request.model';
import { LogOutUserRequestMessage } from './model/logout/logout.request.message';
import { LogOutResponseMessage } from './model/logout/logout.response.message';
import { LocalStorageService } from '../../storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  /** UMS API URL */
  private umsUrl: string;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private localStorage: LocalStorageService
  ) {}

  logout(): Observable<LogOutResponseMessage> {
    this.umsUrl = this.configService.applicationConfig.UmsURL;
    const url = `${this.umsUrl}/aha/logOutUser`;
    const requestMessage = this.createLogoutRequest();

    return this.http
      .post<LogOutResponseMessage>(url, requestMessage, {
        headers: this.getHeaders(),
      })
      .pipe(catchError(this.handleError));
  }

  private createLogoutRequest(): LogOutUserRequestMessage {
    const requestMessage = new LogOutUserRequestMessage();
    const requestContent: BaseRequestModel = {
      ...new BaseRequestModel(),
      ...getBaseRequestData(this.configService.applicationConfig),
    };
    requestMessage.LogOutUserRequestMessage = requestContent;
    return requestMessage;
  }

  private getHeaders(): HttpHeaders {
    const token = this.localStorage.getItem(KEYS.EVERGENT_ACCESS_TOKEN);
    return new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: `Bearer ${
        token === 'undefined'
          ? this.configService.applicationConfig.umsApiToken
          : token
      }`,
    });
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An error occurred';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Backend returned code ${error.status}, body was: ${error.error}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
